var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFuelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Travel/Gas-station"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 8H6V9.5H11.25V8Z",
    fill: "#C93030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3106 6.5L17.5606 2.75L16.5 3.81058L18.75 6.06058V9.5C18.7505 9.89768 18.9086 10.2789 19.1898 10.5602C19.4711 10.8414 19.8523 10.9995 20.25 11V18.875C20.25 19.1734 20.1315 19.4595 19.9205 19.6705C19.7095 19.8815 19.4234 20 19.125 20C18.8266 20 18.5405 19.8815 18.3295 19.6705C18.1185 19.4595 18 19.1734 18 18.875V12.5C18 12.3011 17.921 12.1103 17.7803 11.9697C17.6397 11.829 17.4489 11.75 17.25 11.75H14.25V4.25C14.25 4.05109 14.171 3.86032 14.0303 3.71967C13.8897 3.57902 13.6989 3.5 13.5 3.5H3.75C3.55109 3.5 3.36032 3.57902 3.21967 3.71967C3.07902 3.86032 3 4.05109 3 4.25V20H1.5V21.5H15.75V20H14.25V13.25H16.5V18.8C16.4912 19.4114 16.6923 20.0074 17.0697 20.4885C17.4471 20.9696 17.9781 21.3068 18.5741 21.4438C18.9569 21.5251 19.3531 21.52 19.7337 21.4287C20.1143 21.3374 20.4698 21.1623 20.7741 20.9161C21.0784 20.67 21.3239 20.359 21.4928 20.0059C21.6616 19.6528 21.7495 19.2664 21.75 18.875V7.5608C21.75 7.36379 21.7112 7.16871 21.6358 6.9867C21.5605 6.80469 21.45 6.6393 21.3106 6.5ZM12.75 20H4.5V5H12.75V20Z",
    fill: "#C93030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFuelIcon);
export default __webpack_public_path__ + "static/media/fuel-icon.949464a7b087e5541e5a5989b161bd86.svg";
export { ForwardRef as ReactComponent };